import models from "../models";
import Emitter from "./eventEmitter";

import objects, { store } from "./store";
Object.keys(models).forEach((key) => {
  objects[key] = {};
});
const findOrUpdate = (modelName, obj) => {
  // console.log({ modelName, obj })
  if (!obj._id) throw new Error("Provided object is missing an _id");
  if (!objects[modelName])
    throw new Error(`${modelName} is not an expected model`);
  if (objects[modelName][obj._id]) {
    objects[modelName][obj._id].update(obj);
    Emitter.emit(modelName);
  } else {
    store(modelName, new models[modelName](obj));
  }
  if (objects[modelName][obj._id]) return objects[modelName][obj._id];
  return null;
};
const consume = (modelName = "none", obj) => {
  // console.log({ modelName, obj })
  if (!objects[modelName]) return obj; // throw new Error(`${modelName} is not an expected model`)
  if (obj instanceof Array) {
    return obj.map((o) => findOrUpdate(modelName, o));
  } else if (obj._id) {
    return findOrUpdate(modelName, obj);
  }
};
export default consume;
